import { Metamodel } from '../base/model';
import { IAttribute, IViolation } from '../base/annotation';
import { Activity } from './activity';
import { SqlPool } from '../sqlPool/sqlPool';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ParameterConfigUtils } from '../adapters/linkedservices/parameter-config.util';
import { ParameterConfig } from './parameter-config';
import { ModelConstants } from '../model-constants';
import { sanitizeAndFormatString } from '../../shared/utils/string.util';
import { GlobalVariables } from '../../constants/globals';

@Metamodel.model({
    name: ModelConstants.synapseStoredProcedure,
    referable: true
})
export class SynapseStoredProcedureActivity extends Activity {

    public static readonly NAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.SynapseSqlPool,
        constraint: {
            validator: (activity: SynapseStoredProcedureActivity): IViolation[] | undefined => {
                if (!GlobalVariables.isCmdApiApp && !activity.sqlPool) {
                    return [{
                        message: () => sanitizeAndFormatString(shellStringResources.SQLAnalyticsPoolRequired, activity.name)
                    }];
                }
                return undefined;
            }
        },
        reference: true,
        type: SqlPool.MODEL
    })
    public sqlPool: SqlPool;

    @Metamodel.attribute({
        display: shellStringResources.StoredProcedureName,
        constraint: {
            required: true
        },
        templatable: true,
        association: 'NAME'
    })
    public storedProcedureName?: string;

    @Metamodel.attribute({
        display: shellStringResources.StoredProcedureParameters,
        constraint: {
            validator: ParameterConfigUtils.createParameterConfigurationValidator(true)
        }
    })
    public sprocParameters?: ParameterConfig[] = [];
}
